import { render, staticRenderFns } from "./CateChoose.vue?vue&type=template&id=401ea0df&scoped=true"
import script from "./CateChoose.vue?vue&type=script&lang=js"
export * from "./CateChoose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401ea0df",
  null
  
)

export default component.exports